'use strict'
module.exports = {
  NODE_ENV: '"production"',
  SERVER_ENDPOINT: '"http://api-demo.ovbo.io"',
  LOGO_NAME: "'logo.svg'",
  EXTRAS: [],
  SERVER_SIDE: {}
}
